// extracted by mini-css-extract-plugin
module.exports = {"MobileButton":"AddDistributorButton_MobileButton__hyy47","DesktopButton":"AddDistributorButton_DesktopButton__15UCS"};